import { Fab } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import Chip from "@material-ui/core/Chip";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
// material-ui
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import AccessTokensList from "components/AccessTokensList";
// custom
import App from "components/App";
import FormAccessToken from "components/FormAccessToken";
import FormPersonalInfo from "components/FormPersonalInfo";
// custom
import FormResetPassword from "components/FormResetPassword";
import Page from "components/Page";
import PropTypes from "prop-types";
import React from "react";
// styles
import styles from "./styles";

class WrapperMyAccountPage extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    urlParams: PropTypes.object,
    history: PropTypes.object,
    user: PropTypes.object,
    updateUser: PropTypes.func,
    refresh: PropTypes.func,
    updateUserPassword: PropTypes.func,

    accessTokens: PropTypes.array,
    getAccessTokens: PropTypes.func,
    createAccessToken: PropTypes.func,
    updateAccessToken: PropTypes.func,
    deleteAccessToken: PropTypes.func,

    organizations: PropTypes.array,
    createOrganization: PropTypes.func,
    deleteOrganization: PropTypes.func,
    updateOrganization: PropTypes.func,
    getOrganizations: PropTypes.func,
    getOrganizationUsers: PropTypes.func,
    deleteOrganizationUser: PropTypes.func,
    addUserToOrganization: PropTypes.func,
    joinOrganization: PropTypes.func,

    userApps: PropTypes.array,
  };

  static contextTypes = {
    MessageCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    const { urlParams } = this.props;
    const { MessageCenter } = this.context;
    this.state = {
      accessTokenOpen: false,
      index: urlParams.index ? Number(urlParams.index) : 0,
      selectedOrganization: undefined,
      formOrganizationOpen: false,
    };
    MessageCenter.close("right");
  }

  async onAccessTokenDelete(accessToken) {
    const { deleteAccessToken, refresh } = this.props;
    await deleteAccessToken(accessToken.id);
    refresh();
  }

  getStepContent() {
    const {
      updateUserPassword,
      updateUser,
      user,
      classes,
      refresh,
      accessTokens,
      userApps,
      createOrganization,
      getOrganizations,
      deleteOrganization,
      updateOrganization,
      getOrganizationUsers,
      deleteOrganizationUser,
      addUserToOrganization,
      joinOrganization,
      organizations,
      history,
    } = this.props;

    const { MessageCenter } = this.context;

    const { index, formOrganizationOpen, selectedOrganization } = this.state;

    switch (index) {
      case 0:
        return (
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography display="block" variant="h6" gutterBottom noWrap>
                Your Personal Data
              </Typography>
              <Typography display="block" variant="body2">
                You can here update your personal information such as your first
                and last name, your email and change your password
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormPersonalInfo
                    refresh={refresh}
                    user={user}
                    updateUser={updateUser}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormResetPassword
                    user={user}
                    updateUserPassword={updateUserPassword}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Paper className={classes.padding}>
                    <Typography display="block" variant="h6" gutterBottom>
                      Default App
                    </Typography>
                    <Typography display="block" variant="caption" gutterBottom>
                      Automaticaly launch this app after a login
                    </Typography>
                    <FormControl className={classes.formControl} fullWidth>
                      <InputLabel htmlFor="default-app">Default App</InputLabel>
                      <Select
                        inputProps={{
                          name: "Default App<",
                          id: "default-app",
                        }}
                        value={user.defaultAppID}
                        onChange={async (e) => {
                          await updateUser(user.id, {
                            defaultAppID: e.target.value,
                          });
                          refresh();
                        }}
                      >
                        {userApps.map((a) => (
                          <MenuItem key={`app_${a.id}`} value={a.id}>
                            <Chip
                              avatar={
                                <Avatar style={{ background: "#424242" }}>
                                  <App {...a} size={20} />
                                </Avatar>
                              }
                              key={`chipApp_${a.id}`}
                              className={classes.chip}
                              style={{
                                color: "white",
                                background: "#424242",
                              }}
                              label={`${a.name}`}
                            />
                          </MenuItem>
                        ))}
                        <MenuItem value={-1}>None</MenuItem>
                      </Select>
                    </FormControl>
                  </Paper>
                </Grid>
                <Grid item xs={12}>
                  <Paper className={classes.padding}>
                    <Typography display="block" variant="h6" gutterBottom>
                      Other
                    </Typography>
                    <Grid container>
                      <Typography display="block" variant="body2">
                        Uuid
                      </Typography>
                      <Grid item xs={12}>
                        <Typography
                          display="block"
                          variant="caption"
                          gutterBottom
                        >
                          {user.uuid}
                        </Typography>
                      </Grid>
                      <Typography display="block" variant="body2">
                        Created At
                      </Typography>
                      <Grid item xs={12}>
                        <Typography
                          display="block"
                          variant="caption"
                          gutterBottom
                        >
                          {user.createdAt}
                        </Typography>
                      </Grid>
                      <Typography display="block" variant="body2">
                        Updated At
                      </Typography>
                      <Grid item xs={12}>
                        <Typography
                          display="block"
                          variant="caption"
                          gutterBottom
                        >
                          {user.updatedAt}
                        </Typography>
                      </Grid>
                      <Typography display="block" variant="body2">
                        Id
                      </Typography>
                      <Grid item xs={12}>
                        <Typography
                          display="block"
                          variant="caption"
                          gutterBottom
                        >
                          {user.id}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
                <Grid item xs={12}>
                  <Paper className={classes.padding}>
                    <Typography display="block" variant="h6" gutterBottom>
                      Services & Roles
                    </Typography>
                    {Object.keys(user.services).map((k) => (
                      <div key={`service_${k}`}>
                        <Typography display="block" variant="body2">
                          {k}
                        </Typography>
                        {user.services[k].map((r) => (
                          <Chip
                            key={`role_${k}_${r}`}
                            label={r}
                            className={classes.chip}
                          />
                        ))}
                      </div>
                    ))}
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        );
      case 1:
        return (
          <div>
            <AccessTokensList
              accessTokens={accessTokens}
              onDelete={this.onAccessTokenDelete.bind(this)}
            />
          </div>
        );
      default:
        return (
          <Typography display="block" variant="h6">
            You have gone too far, Sonny Jim !
          </Typography>
        );
    }
  }

  getFab() {
    const { classes } = this.props;
    const { index } = this.state;
    switch (index) {
      case 1:
        return (
          <Fab
            color="primary"
            aria-label="Add"
            className={classes.floatingActionButton}
            onClick={this.openAccessToken.bind(this)}
          >
            <AddIcon />
          </Fab>
        );
      case 2:
        return (
          <Fab
            color="primary"
            aria-label="Add"
            className={classes.floatingActionButton}
            onClick={() => this.setState({ formOrganizationOpen: true })}
          >
            <AddIcon />
          </Fab>
        );
      default:
        return [];
    }
  }

  openAccessToken() {
    this.setState({ accessTokenOpen: true });
  }

  closeAccessToken() {
    this.setState({ accessTokenOpen: false });
  }

  render() {
    const {
      classes,
      history,
      createAccessToken,
      updateAccessToken,
      deleteAccessToken,
      refresh,
    } = this.props;

    const { index, accessTokenOpen, selectedAccessToken } = this.state;

    return (
      <Page
        helmet="My Account"
        loadingMessage={"Loading Information"}
        fab={this.getFab()}
        tabs={
          <React.Fragment>
            <Tabs
              value={index}
              onChange={(e, v) => {
                this.setState({
                  index: v,
                });
                history.push(`?index=${v}`);
              }}
              indicatorColor="primary"
              textColor="primary"
              scrollable
              scrollButtons="auto"
              classes={{
                root: classes.tabsRoot,
                indicator: classes.tabsIndicator,
              }}
            >
              <Tab
                label="My Account"
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
              <Tab
                label="Access Tokens"
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
            </Tabs>
          </React.Fragment>
        }
      >
        {this.getStepContent()}
        <FormAccessToken
          open={accessTokenOpen}
          accessToken={selectedAccessToken}
          close={() => {
            this.closeAccessToken();
            setTimeout(
              () =>
                this.setState({
                  selectedAccessToken: undefined,
                }),
              200
            );
          }}
          createAccessToken={createAccessToken}
          deleteAccessToken={deleteAccessToken}
          updateAccessToken={updateAccessToken}
          refresh={refresh}
        />
      </Page>
    );
  }
}
export default withStyles(styles)(WrapperMyAccountPage);
